<template>
  <Skeleton height="40px" width="94px" />
</template>

<script setup>
import Skeleton from '@nuxt-common/atomic-ui/app/components/skeleton/Skeleton';
</script>
